import React from "react";

const CompletionScreen = () => {
  return (
    <div className="text-center">
      <h2 className="text-2xl font-bold mb-4 text-green-400">
        🎉 Congratulations! 🎉
      </h2>
      <p className="text-lg mb-4">You've completed all the minigames!</p>
      <p className="text-sm text-gray-400">
        Thanks for playing our quiz adventure!
      </p>
    </div>
  );
};

export default CompletionScreen;
